export default __webpack_public_path__ + "static/B0195-c104f3ce6d441f06c1995fb807d26caa.png";